<ion-refresher
  slot="fixed"
  [disabled]="!manualRefresh()"
  (ionRefresh)="onRefresh($event)"
  pullFactor="0.3"
>
  <ion-refresher-content refreshingSpinner="bubbles"></ion-refresher-content>
</ion-refresher>

<div class="scroll-slot">
  <ng-content></ng-content>
</div>

<ion-infinite-scroll
  [disabled]="!infiniteScroll()"
  (ionInfinite)="onLoadMore($event)"
>
  <ion-infinite-scroll-content loadingSpinner="bubbles"></ion-infinite-scroll-content>
</ion-infinite-scroll>

